<template>
  <div class="layouHome">
    <div class="popout model">
      <el-dialog :title="title" class="el-dialogs" width="600px" :visible.sync="importInstrumentVisible"
        :close-on-click-modal="false">

        <el-descriptions class="margin-top" :column="1"  border>
          <el-descriptions-item>
            <template slot="label">
              <span class="label">1.准备</span>
            </template>
            <a :href="xlsxFileUrl" download="instrument_template.xlsx"
              style="color:#74c8fe;margin-bottom:5px;cursor: pointer;">点击下载导入模板</a>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <span class="label">2.录入数据</span>
            </template>
           <span style="color: #74c8fe;">请将您的信息按模板提示仔细填写</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <span class="label">3.上传文件</span>
            </template>
            <el-upload class="upload-demo"  :on-preview="handlePreview" :on-remove="handleRemove"
              :on-change="handleChange" :file-list="fileList" :multiple="false" :auto-upload="false"
              :action="uploadUrl">

              <div class="el-upload__tip" style="color: #f3f4f6;text-align: center;flex-direction: column;
    display: flex;">
                <el-button size="small" type="primary" style="width: 100px;margin-bottom: 10px;">点击上传</el-button>
                <span style="color: #74c8fe;"> 上传仪器导入文件，仅支持xlsx、xls格式文件</span>

              </div>
            </el-upload>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <span class="label">3.上传结果</span>
            </template>
            <div v-if="msgList&&msgList.length">
              <span style="color: red;">导入失败</span>
             <ul>
              <li v-for="item,index in msgList" :key="index">{{ item.toString()}}</li>
             </ul>
            </div>
            
          </el-descriptions-item>


        </el-descriptions>

        <div class="btn-primary">
          <el-button size="small" type="primary" @click="affirm">确认</el-button>
          <el-button size="small" type="" @click="handleClear">清除</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "@/util/request";
import { downBlobFile } from "@/util/util.js";
export default {
  props: ["importInstrumentVisible", "uploadUrl", "title", 'depotId'],
  data() {
    return {
      msgList:[],
      fileList: [],
      xlsxFileUrl: '/public/instrument_template.xlsx'
    }
  },
  watch: {
    importInstrumentVisible(val) {
      if (!val) {
        this.$emit("closeTitle")
      } else {

      }
    }
  },
  methods: {

    downloadTemplate() {

      downBlobFile(
        "/ims/instrument/downloadTemplate",
        "",
        "仪器模板.xlsx"
      ).catch((error) => {
        this.mixin.blobErrorTip(error);
      });
    },
    /** 仪器导入板块方法 **/

    //查看导入文件信息
    handlePreview(file) { console.log(file); },
    //删除文件
    handleRemove(file, fileList) { this.$message.success("删除成功"); },
    //上传文件纪录信息
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    //确定上传
    affirm() {
      if (this.fileList.length == 0) {
        this.$message.error("请选择需要上传的文件");
        return;
      }
      this.myupload(this.fileList[0].raw);
    },
    //清除功能
    handleClear() { this.$set(this, "fileList", []); },
    //上传方法
    myupload(file) {
      let that = this;
      const form = new FormData();
      console.log(that.uploadUrl)
      form.append("file", file);
      axios({
        url: `${that.uploadUrl}?depotId=${this.depotId}`,
        headers: { "Content-Type": "multipart/form-data" },
        method: "post",
        data: form,
      }).then((res) => {
        if (res.code === "200") {
          that.$message.success("上传成功");
          that.handleClear();
          this.$emit("change");
        } else {
          // that.$message.warning(res.msg);
          that.msgList = res.data
          console.log(res,'res')
        }
       
      }).catch((data) => {
        that.$message.error("上传失败,请重新上传!");
      });
    },


  },
}
</script>

<style lang='less' scoped>
.layouHome {
  height: 100%;
  background-image: url("~@/assets/images/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  position: relative;
  //弹框样式


  .popout {
    /deep/.el-form-item {
      border: 2px solid #0090f0;
      border-radius: 6px;
      height: 40px;
      line-height: 40px;
      margin: 20px 0;
      text-align: center;

      .el-form-item__label {
        background-image: linear-gradient(#0479b4, #02407e);
        text-align: center;
        color: #74c8fe;
      }
    }

    .footer {
      display: flex;
      justify-content: center;
      color: #74c8fe;

      .element-list {
        width: 150px;
        cursor: pointer;
        border: 2px solid #0090f0;
        border-radius: 6px;
        height: 30px;
        line-height: 30px;
        margin: 10px 0;
        margin-right: 10px;
        text-align: center;
      }
    }
  }
}

.el-dialogs {
  /deep/ .el-dialog__body {
    padding-top: 10px !important;

  }
  /deep/ .el-descriptions-item__label.is-bordered-label{
    min-width: 90px;
  }
  /deep/ .el-descriptions__body{
    background-color: #092e5f;
  }
  /deep/ .el-descriptions-item__label.is-bordered-label{
    background-color: #092e5f;
    color: #74c8fe;
  }
  /deep/ .el-upload-list__item-name{
    color: #74c8fe;
  }
}

.btn-primary {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  .el-button {
    width: 100px;
  }
}
.label{
  min-width: 100px;
}
ul{
  display: flex;
  flex-direction: column
}
ul li{
  list-style: none;
  color: red;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Instrumentmanagemen/components/instrument.vue